import produce from 'immer';
import { useEffect, useState } from 'react';

import { fontImportUrl } from 'dashboard/components/ThemedFonts/ThemedFonts';
import { ThemeAttributes } from 'dashboard/models/theme';
import useExternalStylesheet from 'lib/hooks/useExternalStylesheet';
import { BrowserFonts, GoogleFonts } from 'lib/interfaces/fonts';

type FontFamilyDefinitions = { [k: string]: string };
const ALL_FONTS: FontFamilyDefinitions = { ...BrowserFonts, ...GoogleFonts };

const createAllFontOptions = (allFonts: FontFamilyDefinitions) => {
  return Object.keys(allFonts)
    .filter(Boolean)
    .sort((a, b) => allFonts[a].localeCompare(allFonts[b]))
    .map((fontKey) => ({
      label: (
        <div key={fontKey} style={{ fontFamily: allFonts[fontKey] }}>
          {allFonts[fontKey]}
        </div>
      ),
      value: allFonts[fontKey],
    }));
};

// Note (Evan): All of this logic is derived from
// dashboard/forms/FormThemeEditorFont/FormThemeEditorFont.tsx
// We could potentially use this hook to replace the inline logic within that file
const useAllThemeFontOptions = (selectedThemeAttributes?: ThemeAttributes) => {
  const [allFontOptions, setAllFontOptions] = useState([]);

  // NOTE: we are calling a hook on a loop on a constant value, so we'll never
  // break the rules of hooks.
  Object.values(GoogleFonts).map((fontFamily) => useExternalStylesheet(fontImportUrl(fontFamily))); // eslint-disable-line react-hooks/rules-of-hooks

  useEffect(() => {
    if (selectedThemeAttributes?.['font-url'] != null) {
      const customFont =
        selectedThemeAttributes['font-family'] ?? selectedThemeAttributes['font-family-title'];
      const allFontsWithCustom = produce(ALL_FONTS, (newFonts) => {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        newFonts[customFont] = customFont;
        return newFonts;
      });
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      setAllFontOptions(createAllFontOptions(allFontsWithCustom));
    } else {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      setAllFontOptions(createAllFontOptions(ALL_FONTS));
    }
  }, [selectedThemeAttributes]);

  return allFontOptions;
};

export default useAllThemeFontOptions;
